<div class="p-9">
  <div class="grid grid-cols-1 md:grid-cols-3 gap-4 !p-4">
    <label class="form-label">{{"ACCOUNT_SETTINGS.CONTACT_INFO.AVATAR" | translate}}</label>
    <div class="col-span-2">

      <img
        class="w-[125px] h-[125px] object-cover shadow-xl rounded-xl"
        src="./assets/media/avatars/blank.png"
        alt=""
        srcset=""
      />
      <!-- } -->
    </div>
    <label class="form-label">{{"ACCOUNT_SETTINGS.CONTACT_INFO.FULL_NAME" | translate}}</label>
    <div class="flex gap-1 w-full col-span-2">
      <input
        class="form-control mr-4"
        pInputText
        [pSize]="'large'"
        [fluid]="true"
        type="text"
        [placeholder]="user().firstName"
        name="firstName"
        [disabled]="true"
      />
      <input
        class="form-control"
        pInputText
        [pSize]="'large'"
        [fluid]="true"
        type="text"
        [placeholder]="user().lastName"
        name="lastName"
        [disabled]="true"
      />
    </div>

    <label class="form-label">{{"ACCOUNT_SETTINGS.CONTACT_INFO.USERNAME" | translate}}</label>

    <input
      class="form-control col-span-2"
      pInputText
      [pSize]="'large'"
      [fluid]="true"
      type="text"
      [placeholder]="user().username"
      name="username"
      [disabled]="true"
    />
    <label class="form-label">{{"ACCOUNT_SETTINGS.CONTACT_INFO.EMAIL" | translate}}</label>
    <input
      class="form-control col-span-2"
      pInputText
      [pSize]="'large'"
      [fluid]="true"
      type="text"
      [placeholder]="user().email"
      name="email"
      [disabled]="true"
    />
  </div>
</div>
